import { createContext } from 'react';

import { createUID } from '../../utils';

import { MenuContextProps } from './Menu.types';

export default createContext<MenuContextProps>({
  mode: 'action',
  variant: 'drill-down',
  scrollAt: 7,
  loading: false,
  componentId: createUID(),
  pushFlyoutId: () => null,
  flyOutActiveIdStack: [],
  focusControl: null,
  updateActiveDescendants: () => null,
  setFocusDescendant: () => null,
  setFocusReturnEl: () => null,
  getScopedItemId: () => ''
});
